import { FilterBar, FilterMultiSelect } from "components/commons";
import { useMount } from "hooks";
import { allLocationRequest } from "mappers";
import React, { useCallback, useMemo } from "react";
import { mapObject } from "services";
import lang from "translations";

const SupplyItemFilter = ({
  filterState,
  requestState,
  modifyFilter,
  clearFilter,
  applyFilter,
  locationRequest,
  locationOptions,
}) => {
  const { request: searchLocationRequest, loading: loadingLocations } = locationRequest;

  useMount(() => {
    fetchLocationRequest(requestState);
  });

  const fetchLocationRequest = useCallback(
    (requestState) => {
      searchLocationRequest(mapObject({ ...requestState }, allLocationRequest));
    },
    [searchLocationRequest]
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      await applyFilter(searchKey);
    },
    [applyFilter]
  );

  const clearFilterCb = useCallback(() => {
    clearFilter();
  }, [clearFilter]);

  const stockLevelOptions = useMemo(() => {
    return [
      {
        text: lang.inStock,
        value: "IN_STOCK",
      },
      {
        text: lang.reachedReorderPoint,
        value: "REACHED_REORDER_POINT",
      },
      {
        text: lang.belowParLevel,
        value: "BELOW_PAR_LEVEL",
      },
      {
        text: lang.zeroInventory,
        value: "OTHERS",
      },
    ];
  }, []);

  return (
    <FilterBar
      placeholder={lang.searchSupplyItemBy}
      className="mb-lg"
      onClear={clearFilterCb}
      onApply={applyFilterCb}
      filterState={filterState}
    >
      <FilterMultiSelect
        id="locations"
        label={lang.outlet}
        allLabel={lang.allLocations}
        emptyLabel={lang.noLocationAvailable}
        disableWhenEmpty={false}
        loading={loadingLocations}
        options={locationOptions}
        value={filterState.locations}
        onChange={(value) => modifyFilter("locations", { value })}
      />
      <FilterMultiSelect
        id="stockLevels"
        label={lang.stockLevels}
        allLabel={lang.allStockLevels}
        options={stockLevelOptions}
        value={filterState.stockLevels}
        onChange={(value) => modifyFilter("stockLevels", { value })}
      />
    </FilterBar>
  );
};

export default SupplyItemFilter;
